document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-luma-add]');
  if (!button || button.disabled) return;
  const offer = button.closest('[data-luma-upsell]');
  const status = offer.querySelector('[role="status"]');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  status.textContent = '';
  try {
    const drawer = document.querySelector('cart-drawer');
    const response = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:button.dataset.lumaAdd,quantity:1}],sections:drawer ? ['cart-drawer','cart-icon-bubble'] : ['main-cart-items','main-cart-footer','cart-icon-bubble'],sections_url:window.location.pathname})
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || window.cartStrings.error);
    if (drawer && result.sections && result.sections['cart-drawer']) {
      drawer.renderContents(result);

    } else window.location.assign(window.routes.cart_url);
  } catch (error) {
    status.textContent = error.message || window.cartStrings.error;
    button.disabled = false;button.removeAttribute('aria-busy');
  }
});
